import { Component } from '@angular/core';

@Component({
  selector: 'app-demand-reduction',
  templateUrl: './demand-reduction.component.html',
  styleUrls: ['./demand-reduction.component.scss']
})
export class DemandReductionComponent {
}
